<template>
  <header class="default header">
    <div class="center-content">
      <div class="row_2 no-gutters">
        <a class="logo" id="logo" href="https://rewards.essilorusa.com/" title="Go to EssilorUSA.com. See More. Do More." aria-label="EssilorUSA.com">
          <img class="img-logo" src="/images/EPR_logo_white.png" alt="Essilor_RGB_Blue">
        </a>
        <label class="logo-title" for="">Essilor <b style="margin-left: 10px">Preferred Rewards Job Ordering Portal</b></label>
        <a class="logo-mobile" href="https://www.essilorusa.com" aria-label="EssilorUSA.com">
          <svg class="icon" width="60" height="45">
            <image href="/images/EPR_logo_white.png" width="60" height="45" alt="EPR_logo_white"></image>
        </svg>
        </a>
        <div class="row_2 no-gutters no-padding" id="desktop-navs-wrapper">
          <div id="aux-nav-wrapper"></div>
          <div id="main-nav-wrapper">

            <nav class="main-nav">
              <ul>
                <li>
                  <p>
                    <router-link to="/">HOME</router-link>
                  </p>
                </li>
                <li>
                  <p>
                    <router-link to="/support">SUPPORT</router-link>
                  </p>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <div class="top-subnav">
        <!--<div class="essilorLogo">
            <a class="logo--essilor" href="http://www.essilorusa.com/" target="_blank">
                <img alt="Essilor Logo" src="/images/Essilor_Logo_SMDM_Framed_RGB.png"> </a>
        </div>-->
        <!--<div class="vNavLine"></div>
        <a href="https://essilorusa.com/transitions">
            <span class="brand-logo brand-logo--transitions"></span>
        </a>
        <a href="https://essilorusa.com/crizal">
            <span class="brand-logo brand-logo--crizal"></span>
        </a>
        <a href="https://essilorusa.com/varilux">
            <span class="brand-logo brand-logo--varilux"></span>
        </a>
        <a href="https://essilorusa.com/eyezen">
            <span class="brand-logo brand-logo--eyezen"></span>
        </a>
        <a href="https://essilorusa.com/xperiouv">
            <span class="brand-logo brand-logo--xperio"></span>
        </a>-->
      </div>
      <!--<div class="navline"></div>-->
      <div id="myTopnav" class="topnav" :class="{'responsive': expanded}">
        <!--<div class="samplingProgramLogo">
            <img class="sitelogo" src="/images/sampling-logo.png" alt=""> </div>-->
        <!--<div class="desktopNav">
            <span>
                <router-link to="/">HOME</router-link>
            </span>
            <span>
                <router-link to="/support">SUPPORT</router-link>
            </span>
        </div>-->
        <div class="icon" @click='toggleMenu'>
          <a href="#" class="mobile-menu">
            <span class="icon-menu"></span>
            <span class="icon-cross"></span>
          </a>
        </div>
        <div class="menu-content">
          <ul>
            <li>
              <router-link to="/">HOME</router-link>
            </li>
            <li>
              <router-link to="/support">SUPPORT</router-link>
            </li>
          </ul>
          <!--<div class="mobile-logos">
              <span class="brand-logo brand-logo--transitions"></span>
              <span class="brand-logo brand-logo--crizal"></span>
              <span class="brand-logo brand-logo--varilux"></span>
              <span class="brand-logo brand-logo--eyezen"></span>
              <span class="brand-logo brand-logo--xperio"></span>
              <a class="logo--essilor" href="http://essilorusa.com/" target="_blank">
                  <img src="/images/essilor-logo.png" alt="Essilor Logo"> </a>
          </div>-->
        </div>
      </div>
    </div>
  </header>
</template>
<script>
export default {
  methods: {
    toggleMenu() {
      this.expanded = !this.expanded;
    }
  },
  data() {
    return {
      expanded: false
    };
  }
};

</script>
<style>
@import url(https://fonts.googleapis.com/css?family=Noto+Sans:400,600,700);
.logo-title {
    display: flex;
    position: absolute;
    margin-top: 22px;
    margin-left: 110px;
    z-index: 9;
    font-family: 'Noto Sans', sans-serif;
    color: #fff;
    font-size: 30px;
    text-transform: uppercase;
    letter-spacing: 2px;
}

@media screen and (max-width: 960px) {
  .logo-title {
    margin-top: 3px;
    margin-left: 100px;
    font-size: 30px;
  }
}

.img-logo {
    width: 80px;
    margin-left: 20px;
    border: 1px solid #5a67ff;
    margin-top: 20px
}

</style>